import React from "react";
import { Dialog, IconButton, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DraggableImageContainer from "./DraggableImage";
import VideoFrameScrubber from "./VideoFrameScrubber";
import { useCarouselContext } from "../../context/CarouselContext";

const AssetImageModal: React.FC = () => {
  const {
    inModal,
    handleCloseViewer,
    isUcViewerActive,
    handleGoTo,
    selectedImageIndex,
    filteredImages,
  } = useCarouselContext();

  const handlePrev = () => {
    const prevIndex = (selectedImageIndex - 1 + filteredImages.length) % filteredImages.length;
    handleGoTo(prevIndex);
  };

  const handleNext = () => {
    const nextIndex = (selectedImageIndex + 1) % filteredImages.length;
    handleGoTo(nextIndex);
  };  

  return (
    <Dialog
      open={inModal}
      onClose={handleCloseViewer}
      PaperProps={{
        id: "fullscreen-viewer",
        sx: {
          width: "auto",
          height: "auto",
          maxWidth: "90vw",
          maxHeight: "90vh",
          backgroundColor: "transparent",
          boxShadow: "none",
          overflow: "visible",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      }}
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        '& .MuiDialog-paper': {
          transform: "none !important",
        },
      }}
    >
      <Paper
        elevation={5}
        sx={{
          width: "80vw",
          height: "80vh",
          backgroundColor: "rgba(0, 0, 0, 0.85)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
          margin: "auto",
          padding: 2
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={handleCloseViewer}
          sx={{ position: "absolute", top: 16, right: 16, color: "white", zIndex: 2 }}
        >
          <CloseIcon />
        </IconButton>

        {/* Prev Button */}
        {!isUcViewerActive && (
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: 8,
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              backgroundColor: "rgba(0,0,0,0.3)",
              zIndex: 2,
              "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
            }}
          >
            ◀
          </IconButton>
        )}

        {/* Next Button */}
        {!isUcViewerActive && (
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              backgroundColor: "rgba(0,0,0,0.3)",
              zIndex: 2,
              "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
            }}
          >
            ▶
          </IconButton>
        )}

        {isUcViewerActive ? 
          <VideoFrameScrubber/> : 
          <DraggableImageContainer />}
      </Paper>
    </Dialog>
  );
};

export default AssetImageModal;
